<div>
  <span class="sr-only">Filter Summary</span>
  <p-panel
    [toggleable]="true"
    header="Filter"
    [(collapsed)]="panelCollapsed"
    styleClass="panel-filter border mb-3"
  >
    <ng-template #icons>
      <i
        role="button"
        tabindex="0"
        [ngClass]="
          panelCollapsed ? 'pi pi-chevron-circle-down' : 'pi pi-chevron-circle-up'
        "
        (click)="panelCollapsed = !panelCollapsed"
        (keydown.enter)="panelCollapsed = !panelCollapsed"
      >
        <span class="sr-only">
          {{ panelCollapsed ? 'Expand the filter' : 'Collapse the filter' }}
        </span>
      </i>
    </ng-template>

    <ng-template #header>
      <div *ngIf="panelCollapsed" class="selected-filters-display">
        <div class="row">
          <div class="col-sm-12">
            <ng-container *ngIf="!externalUser">
              <span class="heading-color semi-bold-text">Account name:</span>
              {{ summary.accountName }} |
            </ng-container>
            <span class="heading-color semi-bold-text">Client Name:</span>
            {{ summary.clientName }} |
            <span class="heading-color semi-bold-text">Order owner:</span>
            {{ summary.orderOwner }}
          </div>
          <div class="col-sm-12">
            <ng-container *ngIf="!externalUser">
              <span class="heading-color semi-bold-text">Created by:</span>
              {{ summary.createdBy }} |
            </ng-container>
            <span class="heading-color semi-bold-text">Type of order:</span>
            {{ summary.orderType }}
          </div>
        </div>
      </div>
    </ng-template>

  <div class="row" *ngIf="!panelCollapsed">
    <div class="{{!externalUser ? 'width-20' : 'col-sm-3'}} col-12 mb-3 mb-lg-0" *ngIf="!externalUser">
      <label for="account-name" class="form-label d-block">Account Name</label>
      <p-multiselect
      appMultiselectTabFix
        inputId="account-name"
        [options]="options.accountName"
        [(ngModel)]="ordersListFilter.accountName"
        (onChange)="onSelectAccountName()"
        optionLabel="label"
        placeholder="Select account name"
        styleClass="w-100"
        optionValue="value"
        [maxSelectedLabels]="1"
        appendTo="body"
      ></p-multiselect>
    </div>
    <div class="{{!externalUser ? 'width-20' : 'col-sm-3'}} col-12 mb-3 mb-lg-0">
      <label for="client-name" class="form-label d-block">Client Name</label>
      <p-multiselect
      appMultiselectTabFix
        inputId="client-name"
        [options]="options.clientName"
        [(ngModel)]="ordersListFilter.clientName"
        optionLabel="label"
        placeholder="Select client name"
        styleClass="w-100"
        optionValue="value"
        [maxSelectedLabels]="1"
      ></p-multiselect>
    </div>
    <div class="{{!externalUser ? 'width-20' : 'col-sm-3'}} col-12 mb-3 mb-lg-0">
      <label for="order-owner" class="form-label d-block">Order Owner</label>
      <p-multiselect
      appMultiselectTabFix
        [options]="options.orderOwner"
        styleClass="w-100"
        inputId="order-owner"
        placeholder="Select order owner"
        [(ngModel)]="ordersListFilter.orderOwner"
        optionLabel="label"
        optionValue="value"
        [maxSelectedLabels]="1"
      ></p-multiselect>
    </div>
    <div class="{{!externalUser ? 'width-20' : 'col-sm-3'}} col-12 mb-3 mb-lg-0" *ngIf="!externalUser">
      <label for="created-by" class="form-label d-block">Created By</label>
      <p-multiselect
      appMultiselectTabFix
        [options]="options.createdBy"
        styleClass="w-100"
        inputId="created-by"
        placeholder="Select created by"
        [(ngModel)]="ordersListFilter.createdBy"
        optionLabel="label"
        optionValue="value"
        [maxSelectedLabels]="1"
      ></p-multiselect>
    </div>
    <div class="{{!externalUser ? 'width-20' : 'col-sm-3'}} col-12 mb-3 mb-lg-0">
      <label for="order-type" class="form-label d-block">Order Type</label>
      <p-multiselect
      appMultiselectTabFix
        [options]="options.orderType"
        styleClass="w-100"
        inputId="order-type"
        placeholder="Select order type"
        [(ngModel)]="ordersListFilter.orderType"
        optionLabel="label"
        optionValue="value"
        [maxSelectedLabels]="1"
        appendTo="body"
      ></p-multiselect>
    </div>
  </div>
  <div class="d-flex border-top pt-3 mt-0 mt-lg-3" *ngIf="!panelCollapsed">
    <p-button label="Apply Filter" (onClick)="applyFilters()" />
    <p-button
      label="Clear Filter"
      [link]="true"
      (click)="resetFilters()"
      styleClass="px-0"
      class="reset-button"
    />
  </div>
</p-panel>
</div>
